import React from 'react';
import { Avatar, Box } from 'lib/cortiUI';
export function ReviewersList(props) {
    const { reviewers } = props;
    return (React.createElement(Box, { flexDirection: "row", flexWrap: "wrap", "data-cy": "feedback-reviewers-list" }, reviewers.map((reviewer) => {
        return React.createElement(Avatar, { titleText: reviewer.name, key: reviewer.id, m: 1 });
    })));
}
